// Settings API Service
import api from './api';

export interface UserSettings {
  id: string;
  userId: string;
  theme: string;
  notifications: boolean;
  language: string;
  timezone: string;
  onboardingCompleted: boolean;
  createdAt: string;
  updatedAt: string;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

class SettingsService {
  async getSettings(): Promise<UserSettings> {
    const response = await api.get<ApiResponse<UserSettings>>('/settings');
    return response.data.data;
  }

  async updateSettings(updates: {
    theme?: string;
    notifications?: boolean;
    language?: string;
    timezone?: string;
    onboardingCompleted?: boolean;
  }): Promise<UserSettings> {
    const response = await api.put<ApiResponse<UserSettings>>('/settings', updates);
    return response.data.data;
  }

  async completeOnboarding(): Promise<UserSettings> {
    const response = await api.post<ApiResponse<UserSettings>>('/settings/onboarding/complete');
    return response.data.data;
  }

  async getOnboardingStatus(): Promise<boolean> {
    const response = await api.get<ApiResponse<{ onboardingCompleted: boolean }>>('/settings/onboarding/status');
    return response.data.data.onboardingCompleted;
  }
}

export const settingsService = new SettingsService();
export default settingsService;
